module.exports = __webpack_public_path__ + "media/images/front/ogp-edd017bfd01dc553c8c519c2e9187df8.png";